__turbopack_context__.v({
  "addressBlock": "swap-module__qMEMRq__addressBlock",
  "amountMeta": "swap-module__qMEMRq__amountMeta",
  "amountRow": "swap-module__qMEMRq__amountRow",
  "amounts": "swap-module__qMEMRq__amounts",
  "back": "swap-module__qMEMRq__back",
  "bitcoin": "swap-module__qMEMRq__bitcoin",
  "coinButton": "swap-module__qMEMRq__coinButton",
  "coinIcon": "swap-module__qMEMRq__coinIcon",
  "coinList": "swap-module__qMEMRq__coinList",
  "coinOption": "swap-module__qMEMRq__coinOption",
  "coinStack": "swap-module__qMEMRq__coinStack",
  "depositAmount": "swap-module__qMEMRq__depositAmount",
  "destination": "swap-module__qMEMRq__destination",
  "destinationCheck": "swap-module__qMEMRq__destinationCheck",
  "detailRow": "swap-module__qMEMRq__detailRow",
  "direction": "swap-module__qMEMRq__direction",
  "disclosure": "swap-module__qMEMRq__disclosure",
  "embedded": "swap-module__qMEMRq__embedded",
  "embeddedHeading": "swap-module__qMEMRq__embeddedHeading",
  "empty": "swap-module__qMEMRq__empty",
  "error": "swap-module__qMEMRq__error",
  "fieldLabel": "swap-module__qMEMRq__fieldLabel",
  "fixedCoin": "swap-module__qMEMRq__fixedCoin",
  "fullAddress": "swap-module__qMEMRq__fullAddress",
  "heading": "swap-module__qMEMRq__heading",
  "inlineCopy": "swap-module__qMEMRq__inlineCopy",
  "memo": "swap-module__qMEMRq__memo",
  "muted": "swap-module__qMEMRq__muted",
  "networkBadge": "swap-module__qMEMRq__networkBadge",
  "note": "swap-module__qMEMRq__note",
  "page": "swap-module__qMEMRq__page",
  "panel": "swap-module__qMEMRq__panel",
  "picker": "swap-module__qMEMRq__picker",
  "placeholder": "swap-module__qMEMRq__placeholder",
  "primary": "swap-module__qMEMRq__primary",
  "progress": "swap-module__qMEMRq__progress",
  "progressIcon": "swap-module__qMEMRq__progressIcon",
  "qr": "swap-module__qMEMRq__qr",
  "quickCoins": "swap-module__qMEMRq__quickCoins",
  "rateDetails": "swap-module__qMEMRq__rateDetails",
  "receive": "swap-module__qMEMRq__receive",
  "receiveBox": "swap-module__qMEMRq__receiveBox",
  "refund": "swap-module__qMEMRq__refund",
  "route": "swap-module__qMEMRq__route",
  "routeSection": "swap-module__qMEMRq__routeSection",
  "routes": "swap-module__qMEMRq__routes",
  "search": "swap-module__qMEMRq__search",
  "secondary": "swap-module__qMEMRq__secondary",
  "sendBox": "swap-module__qMEMRq__sendBox",
  "spin": "swap-module__qMEMRq__spin",
  "spinner": "swap-module__qMEMRq__spinner",
  "steps": "swap-module__qMEMRq__steps",
  "support": "swap-module__qMEMRq__support",
  "swap": "swap-module__qMEMRq__swap",
  "tabs": "swap-module__qMEMRq__tabs",
});
